import { useEffect, useState } from "react";
import useFetch from "./AddCrew";
import Select from "react-select";
import {
  updateTimeEntry,
  getOtherEntryDetails,
  getProjectTask,
  getCostCodes,
  getCostCodesByProjectId,
} from "../API";
import TimePickerComponent from "./TimePicker";
import {
  convertHoursToMinutes,
  formatTimeForBackend,
  convertMinutesToHours,
  convertTimesToMinutes,
  formatTimeEntry,
} from "../utils/utils";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import TimeDropdown from "./TimerDropdown";
import React from "react";
import SubmissionWarningModal from "./modal/SubmissionWarningModal";
import { IsTimeSheetStatusChanged } from "../utils/apiUtils";
import "../assets/styles/time-entry-drawer.scss";

const EditEquipmentTimeCard = (props) => {
  const location = useLocation();
  const {
    selectedUserValue,
    entryType,
    addCrewModal,
    crew_id,
    project_id,
    getTimeSheetWeekDetails,
    timeSheetDetails,
    projectOptions,
  } = props;
  useFetch(addCrewModal, crew_id, project_id, entryType);

  const { default_cost_code } = JSON.parse(localStorage.getItem("themeData"));
  const [isTaskEditable, setIsTaskEditable] = useState(true);
  const [selectedTask, setSelectedTask] = useState();
  // const [timeCardDetails, setTimeCardDetails] = useState();
  const [time, setTime] = useState({
    punchIn: { hours: 1, minutes: "00", ampm: "PM" },
    punchOut: { hours: 2, minutes: "00", ampm: "PM" },
    workingTimeIn: { hours: 8, minutes: "30", ampm: "AM" },
    workingTimeOut: { hours: 5, minutes: "00", ampm: "PM" },
  });
  const [isEditable, setIsEditable] = useState(true);
  const [, setOtherTimeEntries] = useState([]);
  const [projectTaskOptions, setProjectTaskOptions] = useState([]);
  const [projectCostCodes, setProjectCostCodes] = useState([]);
  const [notes, setNotes] = useState("");
  const [selectedHour, setSelectedHour] = useState(0);
  const [selectedMinute, setSelectedMinute] = useState(0);
  const [combinedTime, setCombinedTime] = useState(0.0);
  const [selectedProject, setSelectedProject] = useState();
  const [dropDownLoading, setDropDownLoading] = useState(false);
  const [lunchToggle, setLunchToggle] = useState(false);
  const [selectedCostCode, setSelectedCostCode] = useState();
  const [submissionWarningModal, setSubmissionWarningModal] = useState(false);


  const setUserWorkTime = (selectedUserValue) => {
    if (selectedUserValue) {
      const time_entry_in = selectedUserValue?.time_entry_in;
      const time_entry_out = selectedUserValue?.time_entry_out;
      const time_lunch_start = selectedUserValue?.time_lunch_start;
      const time_lunch_end = selectedUserValue?.time_lunch_end;
      const offlines = convertMinutesToHours(selectedUserValue?.offline);
      const time_entry_in_hours = parseInt(time_entry_in?.slice(0, 2));
      const time_entry_in_minutes = time_entry_in?.slice(3, 5);
      const time_entry_in_AM_PM = time_entry_in?.slice(6, 9);
      const [hours, minutes] = offlines?.split(".");
      if (hours && minutes) {
        setSelectedHour(hours);
        setSelectedMinute(minutes);
      }

      const time_entry_out_hours = parseInt(time_entry_out?.slice(0, 2));
      const time_entry_out_minutes = time_entry_out?.slice(3, 5);
      const time_entry_out_AM_PM = time_entry_out?.slice(6, 9);

      if (time_lunch_start && time_lunch_end) {
        setLunchToggle(true);
        const lunch_entry_in_hours = parseInt(time_lunch_start?.slice(0, 2));
        const lunch_entry_in_minutes = time_lunch_start?.slice(3, 5);
        const lunch_entry_in_AM_PM = time_lunch_start?.slice(6, 9);

        const lunch_entry_out_hours = parseInt(time_lunch_end?.slice(0, 2));
        const lunch_entry_out_minutes = time_lunch_end?.slice(3, 5);
        const lunch_entry_out_AM_PM = time_lunch_end?.slice(6, 9);

        setTime({
          workingTimeIn: {
            hours: time_entry_in_hours,
            minutes: time_entry_in_minutes,
            ampm: time_entry_in_AM_PM,
          },
          workingTimeOut: {
            hours: time_entry_out_hours,
            minutes: time_entry_out_minutes,
            ampm: time_entry_out_AM_PM,
          },
          punchIn: {
            hours: lunch_entry_in_hours,
            minutes: lunch_entry_in_minutes,
            ampm: lunch_entry_in_AM_PM,
          },
          punchOut: {
            hours: lunch_entry_out_hours,
            minutes: lunch_entry_out_minutes,
            ampm: lunch_entry_out_AM_PM,
          },
        });
      } else {
        setLunchToggle(false);
        setTime({
          workingTimeIn: {
            hours: time_entry_in_hours,
            minutes: time_entry_in_minutes,
            ampm: time_entry_in_AM_PM,
          },
          workingTimeOut: {
            hours: time_entry_out_hours,
            minutes: time_entry_out_minutes,
            ampm: time_entry_out_AM_PM,
          },
          punchIn: { hours: 1, minutes: "00", ampm: "PM" },
          punchOut: { hours: 2, minutes: "00", ampm: "PM" },
        });
      }
    }
  };

  const onHandleChange = async (item) => {
    setProjectCostCodes(null);
    setSelectedProject(item);
    setSelectedTask(null);
    setSelectedCostCode(null);
  };

  useEffect(() => {
    setIsEditable(true);
    setIsTaskEditable(true);
  }, [selectedUserValue]);

  useEffect(() => {
    if (selectedProject?.value?.id || selectedUserValue) {
      getAllProjectTasks(selectedProject?.value?.id);
    }
  }, [selectedProject?.value?.id, selectedUserValue]);

  useEffect(() => {
    if (selectedUserValue?.notes) {
      setNotes(selectedUserValue?.notes);
    } else {
      setNotes("");
    }
  }, [selectedUserValue?.notes, selectedUserValue]);

  useEffect(() => {
    setIsTaskEditable(true);
    setOtherTimeEntries([]);
    setUserWorkTime(selectedUserValue);
    if (selectedUserValue?.other_entries?.length > 0) {
      selectedUserValue?.other_entries?.map((item) => {
        fetchOtherTimeEntries(item?.time_entry_id, item?.crew_id);
      });
    } else {
      setOtherTimeEntries([]);
    }
  }, [selectedUserValue]);

  useEffect(() => {
    if (projectOptions?.length > 0) {
      onHandleChange({
        label: `(${selectedUserValue?.project_number}) ${selectedUserValue?.project_name}`,
        value: {
          id: selectedUserValue?.project_id,
          type: selectedUserValue?.project_type,
        },
      });
    }
  }, [selectedUserValue?.acumatica_id]);

  useEffect(() => {
    if (isTaskEditable && projectTaskOptions?.length > 0) {
      const isProjectTaskExists = projectTaskOptions?.find(
        (ele) =>
          ele?.label === selectedUserValue.task &&
          ele?.value?.id === selectedUserValue?.project_task_id
      );
      if (isProjectTaskExists) {
        setSelectedTask({
          label: selectedUserValue.task,
          value: { id: selectedUserValue?.project_task_id },
        });
        setIsTaskEditable(false);
      } else {
        setSelectedTask(null);
        // setIsTaskEditable(false);
      }
    }
  }, [selectedUserValue, projectTaskOptions]);

  useEffect(() => {
    if (selectedProject?.value?.type === "acumatica") {
      fetchCostCodes({
        value: {
          id: selectedUserValue.project_task_id,
        },
      });
    } else if (selectedProject?.value?.type === "webtime") {
      fetchTempProjectCostCodes({
        value: {
          id: selectedUserValue.project_task_id,
        },
      });
    }
  }, [selectedProject?.value?.id, selectedUserValue]);

  useEffect(() => {
    if (isEditable && projectCostCodes?.length > 0) {
      const costCode = projectCostCodes?.find(
        (ele) => ele?.value?.cost_code === selectedUserValue?.cost_code
      );
      if (costCode) {
        setSelectedCostCode({
          label: costCode?.label,
          value: { id: costCode?.value?.id },
        });
      } else {
        setSelectedCostCode(null);
      }
      setIsEditable(false);
    }
  }, [selectedUserValue, projectCostCodes]);

  const getAllProjectTasks = async (id) => {
    setDropDownLoading(true);
    await getProjectTask(id).then((res) => {
      if (res?.status === 200) {
        const dropDownOptions = res?.data?.map((ele) => {
          return { label: ele?.description, value: ele };
        });
        setProjectTaskOptions(dropDownOptions);
      }
      setDropDownLoading(false);
    });
  };

  const fetchTempProjectCostCodes = async () => {
    await getCostCodes(selectedProject?.value?.id).then((res) => {
      if (res?.data) {
        const tempCostCodes = res?.data?.map((ele) => {
          return {
            label: ele?.description,
            value: ele,
          };
        });
        setProjectCostCodes(tempCostCodes);
      }
    });
  };

  const fetchCostCodes = async (item) => {
    setDropDownLoading(true);
    if (selectedProject?.value?.id) {
      const payload = {
        id: selectedProject?.value?.id,
        is_default: true,
        query: `project_task_id=${item?.value?.id}`,
      };
      await getCostCodesByProjectId(
        payload?.id,
        payload?.is_default,
        payload?.query
      ).then(async (res) => {
        if (res?.data?.length > 0) {
          const projectCostCodeOptions = res?.data?.map((costCode) => {
            return { label: costCode?.description, value: costCode };
          });
          setProjectCostCodes(projectCostCodeOptions);
        }
        setDropDownLoading(false);
      });
    }
  };

  const fetchOtherTimeEntries = async (timeEntryId, crewId) => {
    const data = {
      week: selectedUserValue?.week,
      crewId,
      timeEntryId,
    };
    await getOtherEntryDetails(data, "2").then((res) => {
      if (res?.status === 200) {
        setOtherTimeEntries((previousState) => [
          ...previousState,
          {
            crewName: res?.data[0]?.name,
            timeEntryIn: res?.data[0]?.time_entry_in,
            timeEntryOut: res?.data[0]?.time_entry_out,
            hours: res?.data[0]?.hours,
          },
        ]);
      }
    });
  };

  const updateCombinedTime = (hour, minute) => {
    const combined = parseFloat(hour) + parseFloat(minute) / 100;
    setCombinedTime(combined.toFixed(2));
  };

  const handleHourChange = (e) => {
    const hour = parseInt(e.target.value);
    setSelectedHour(hour);
    updateCombinedTime(hour, selectedMinute);
  };

  const handleMinuteChange = (e) => {
    const minute = parseInt(e.target.value);
    setSelectedMinute(minute);
    updateCombinedTime(selectedHour, minute);
  };


  const onClickSave = async () => {
    const timeSheetStatusChanged = await IsTimeSheetStatusChanged(
      timeSheetDetails?.id
    );
    if (
      timeSheetStatusChanged &&
      location.pathname.includes("/timesheet-card")
    ) {
      setSubmissionWarningModal(true);
      return;
    } else {
      const id = selectedUserValue?.time_entry_id;
      const lunchTimeIn = formatTimeForBackend(time?.punchIn);
      const lunchTimeOut = formatTimeForBackend(time?.punchOut);
      const entryTimeIn = formatTimeEntry(time?.workingTimeIn, "entryTimeIn");
      const entryTimeOut = formatTimeEntry(
        time?.workingTimeOut,
        "entryTimeOut"
      );
      if (
        convertTimesToMinutes(entryTimeIn) -
          convertTimesToMinutes(entryTimeOut) >=
          0 ||
        convertTimesToMinutes(entryTimeIn) -
          convertTimesToMinutes(entryTimeOut) ===
          -24 ||
        convertTimesToMinutes(entryTimeIn) ===
          convertTimesToMinutes(entryTimeOut) ||
        (lunchToggle &&
          (convertTimesToMinutes(lunchTimeIn) -
            convertTimesToMinutes(lunchTimeOut) >=
            0 ||
            convertTimesToMinutes(lunchTimeIn) -
              convertTimesToMinutes(lunchTimeOut) ===
              -24 ||
            convertTimesToMinutes(lunchTimeIn) -
              convertTimesToMinutes(entryTimeIn) <
              0 ||
            convertTimesToMinutes(lunchTimeIn) -
              convertTimesToMinutes(entryTimeOut) >
              0 ||
            convertTimesToMinutes(lunchTimeOut) -
              convertTimesToMinutes(entryTimeIn) <
              0 ||
            convertTimesToMinutes(lunchTimeOut) -
              convertTimesToMinutes(entryTimeOut) >
              0))
      ) {
        toast.warn("Invalid time-range for work or lunch");
      } else if (!selectedProject?.value?.id || !selectedTask?.value?.id) {
        toast.warn("Project or project task is empty");
      } else {
        const payload = {
          time_entry_in: entryTimeIn,
          time_entry_out: entryTimeOut,
          time_lunch_start: lunchToggle ? lunchTimeIn : null,
          time_lunch_end: lunchToggle ? lunchTimeOut : null,
          // project_cost_code_id: selectedCostCodeId,
          project_id: selectedProject?.value?.id,
          project_task_id: selectedTask?.value?.id,
          offline: combinedTime ? convertHoursToMinutes(combinedTime) : 0.0,
          notes,
        };
        await updateTimeEntry(payload, id)
          .then((res) => {
            if (res?.status === 200) {
              toast.success("Time Entry Updated Successfully");
              getTimeSheetWeekDetails(timeSheetDetails);
            }
          })
          .catch((err) => toast.error("Error Occured while updating"));
      }
    }
  };

  // const getMyTimeCardDetails = async () => {
  //   await getTimeCard(selectedUserValue?.crew_project_cost_code_id).then(
  //     (res) => {
  //       if (res?.status === 200) {
  //         console.log(
  //           "timeCardDetailstimeCardDetailstimeCardDetails",
  //           timeCardDetails
  //         );
  //         setTimeCardDetails(res?.data);
  //         const lunchIn = parseTime(res?.data?.time_lunch_start);
  //         const lunchOut = parseTime(res?.data?.time_lunch_end);
  //         const workIn = parseTime(res?.data?.time_entry_in);
  //         const workOut = parseTime(res?.data?.time_entry_out);
  //         console.log("lunchInlunchIn",lunchIn);

  //         // setTime({
  //         //   punchIn: {
  //         //     hours: lunchIn?.hour,
  //         //     minutes: lunchIn?.minutes,
  //         //     ampm: lunchIn?.ampm,
  //         //   },
  //         //   punchOut: {
  //         //     hours: lunchOut?.hour,
  //         //     minutes: lunchOut?.minutes,
  //         //     ampm: lunchOut?.ampm,
  //         //   },
  //         //   workingTimeIn: {
  //         //     hours: workIn?.hour,
  //         //     minutes: workIn?.minutes,
  //         //     ampm: workIn?.ampm,
  //         //   },
  //         //   workingTimeOut: {
  //         //     hours: workOut?.hour,
  //         //     minutes: workOut?.minutes,
  //         //     ampm: workOut?.ampm,
  //         //   },
  //         // });
  //       }
  //     }
  //   );
  // };


  const onTaskChange = (item) => {
    setSelectedTask(item);
    setSelectedCostCode(null);
    if (selectedProject?.value?.type === "acumatica") {
      setProjectCostCodes(null);
      fetchCostCodes(item);
    }
  };

  const onCostCodeChange = (item) => {
    setSelectedCostCode(item);
  };

  const handleTimeSelectChange = (field, value, type) => {
    const copiedTime = { ...time };
    copiedTime[type][field] = value;
    setTime(copiedTime);
  };

  return (
    time && (
      <>
        <div
          className="offcanvas offcanvas-end crew-mdal"
          tabindex="-1"
          id="editEquipmentSideModal"
          aria-labelledby="offcanvasRightLabel"
        >
          <div className="offcanvas-header">
            <h3 id="offcanvasRightLabel">Edit Equipment Time Entry</h3>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <div className="time-entry-field">
              <label htmlFor="" className="time-entry-label">
                Name
              </label>
              <input
                disabled={true}
                value={selectedUserValue?.name}
                name="name"
                type="text"
                className="form-control"
              />
            </div>
            <div className="time-entry-field">
              <label htmlFor="" className="time-entry-label">
                Project *
              </label>
              <Select
                placeholder="Select Project"
                value={selectedProject}
                className="react-select-container"
                classNamePrefix="react-select"
                name="colors"
                options={projectOptions}
                onChange={(item) => onHandleChange(item)}
              />
            </div>
            <div className="time-entry-field">
              <label htmlFor="" className="time-entry-label">
                Project Task *
              </label>
              <Select
                value={selectedTask}
                isLoading={dropDownLoading}
                placeholder={"Select"}
                className="react-select-container"
                classNamePrefix="react-select"
                name="colors"
                options={projectTaskOptions}
                onChange={(item) => onTaskChange(item)}
              />
            </div>
            {!default_cost_code && (
              <div className="time-entry-field">
                <label htmlFor="" className="time-entry-label">
                  Cost Code *
                </label>
                <Select
                  value={selectedCostCode}
                  isLoading={dropDownLoading}
                  placeholder={"Select"}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  name="colors"
                  options={projectCostCodes}
                  onChange={(item) => onCostCodeChange(item)}
                />
              </div>
            )}
            {/* <div className="input-flex">
              <label htmlFor="" className="col-form-label">
                Cost Code
              </label>
              <div className="input-box">
                <Select
                  placeholder={
                    costCodeLabel?.value?.project_cost_code?.description
                  }
                  className="react-select-container"
                  classNamePrefix="react-select"
                  name="colors"
                  options={costCodesOptions}
                  onChange={(item) => onCostCodeChange(item)}
                />
              </div>
            </div> */}
            <div className="time-entry-field">
              <label htmlFor="" className="time-entry-label">
                Working Time
              </label>
              <div className="time-entry-time-row d-flex align-items-center justify-content-between row">
                <div className="col-6">
                  <TimePickerComponent
                    label={"Start"}
                    time={time?.workingTimeIn}
                    type="workingTimeIn"
                    handleTimeSelectChange={handleTimeSelectChange}
                  />
                </div>
                <div className="col-6">
                  <TimePickerComponent
                    label={"End"}
                    time={time?.workingTimeOut}
                    type="workingTimeOut"
                    handleTimeSelectChange={handleTimeSelectChange}
                  />
                </div>
              </div>
            </div>
            <div className="time-entry-field">
              <label htmlFor="" className="time-entry-label">
                Offline
              </label>
              <TimeDropdown
                handleHourChange={handleHourChange}
                handleMinuteChange={handleMinuteChange}
                selectedHour={selectedHour}
                selectedMinute={selectedMinute}
              />
            </div>
            <div className="time-entry-field">
              <label htmlFor="" className="time-entry-label">
                Notes
              </label>
              <textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                rows="3"
                className="textarea"
              />
            </div>
            <div className="time-entry-field">
              <button
                onClick={() => setLunchToggle((prevState) => !prevState)}
                type="button"
                className="primary-btn lunch time-entry-lunch-btn"
              >
                Break Time
              </button>
              {lunchToggle && (
                <div className="time-entry-time-row d-flex align-items-center justify-content-between row mt-2">
                  <div className="col-6">
                    <TimePickerComponent
                      label={"Start"}
                      time={time?.punchIn}
                      type="punchIn"
                      handleTimeSelectChange={handleTimeSelectChange}
                    />
                  </div>
                  <div className="col-6">
                    <TimePickerComponent
                      label={"End"}
                      time={time?.punchOut}
                      type="punchOut"
                      handleTimeSelectChange={handleTimeSelectChange}
                    />
                  </div>
                </div>
              )}
            </div>
            {/* {otherTimeEntries.length > 0 && (
              <>
                <div className="add-entry">
                  <h4>Additional time entries</h4>
                  {otherTimeEntries.map((item) => (
                    <p>
                      {item?.crewName}- ({item?.hours} hours)
                    </p>
                  ))}
                </div>
              </>
            )} */}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="primary-btn-outlined"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              Cancel
            </button>
            <button
              onClick={() => onClickSave()}
              type="button"
              className="primary-btn"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              Save
            </button>
          </div>
        </div>
        <SubmissionWarningModal isOpen={submissionWarningModal} />
      </>
    )
  );
};

export default EditEquipmentTimeCard;
